import React from 'react';
import '../styles/components/loading.css';

export function Loading() {
    return (
        <div className="loading">
            <p>Loading...</p>
        </div>
    )
}